import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=c0610818&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0610818')) {
      api.createRecord('c0610818', component.options)
    } else {
      api.reload('c0610818', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=c0610818&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml", function () {
      api.rerender('c0610818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/OCA/Form2_Persona.vue"
export default component.exports